import { render, staticRenderFns } from "./PartyBalance.vue?vue&type=template&id=31450928&scoped=true"
import script from "./PartyBalance.vue?vue&type=script&lang=js"
export * from "./PartyBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31450928",
  null
  
)

export default component.exports